/* Page "Notre jardin" — statut en direct, barre CTA fixe, RSVP, suivi GTM */
(function () {
  'use strict';

  function track(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (data) {
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) payload[key] = data[key];
      }
    }
    window.dataLayer.push(payload);
  }

  /* Clics instrumentés : data-gtm-event, liens tel: et liens Google Maps */
  document.addEventListener('click', function (evt) {
    var el = evt.target.closest('[data-gtm-event]');
    if (el) {
      track(el.getAttribute('data-gtm-event'));
      return;
    }
    var link = evt.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href.indexOf('tel:') === 0) {
      track('click_phone');
    } else if (href.indexOf('mailto:') === 0) {
      track('click_email');
    } else if (/google\.[^/]+\/maps/.test(href)) {
      track('click_directions');
    }
  });

  /* Inscription à l'infolettre (formulaires client Shopify de la page) */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (form.querySelector && form.querySelector('input[name="contact[email]"]')) {
      track('newsletter_signup');
    }
  });

  function parseLocalDate(iso) {
    if (!iso) return null;
    var parts = iso.split('-');
    if (parts.length !== 3) return null;
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  /* Badge de statut en direct (le rendu Liquid sert de repli sans JS) */
  function initStatusBadges() {
    var badges = document.querySelectorAll('[data-garden-status]');
    if (!badges.length) return;

    badges.forEach(function (badge) {
      var start = parseLocalDate(badge.getAttribute('data-season-start'));
      var end = parseLocalDate(badge.getAttribute('data-season-end'));
      var openHour = parseInt(badge.getAttribute('data-open-hour') || '10', 10);
      var closeHour = parseInt(badge.getAttribute('data-close-hour') || '17', 10);
      if (!start || !end) return;

      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var endOfSeason = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
      var text;
      var closed = false;

      if (now < start) {
        text = badge.getAttribute('data-label-upcoming');
        closed = true;
      } else if (now > endOfSeason) {
        text = badge.getAttribute('data-label-over');
        closed = true;
      } else if (now.getHours() < openHour) {
        text = badge.getAttribute('data-label-opens-later');
        closed = true;
      } else if (now.getHours() < closeHour) {
        text = badge.getAttribute('data-label-open');
      } else {
        var tomorrow = new Date(today.getTime() + 86400000);
        text = tomorrow > end ? badge.getAttribute('data-label-over') : badge.getAttribute('data-label-closed-tonight');
        closed = true;
      }

      if (text) {
        badge.textContent = text;
        badge.classList.toggle('sdp-badge--closed', closed);
      }
    });
  }

  /* Barre CTA fixe : apparaît une fois le héros dépassé */
  function initStickyBar() {
    var bar = document.querySelector('.sdp-sticky');
    if (!bar) return;
    var hero = document.querySelector('.sdp-hero');

    if (!hero || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { rootMargin: '-120px 0px 0px 0px' }
    ).observe(hero);
  }

  /* Calendrier des activités : événement à la première mise en vue */
  function initCalendarTracking() {
    var calendar = document.querySelector('[data-garden-events]');
    if (!calendar) return;

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        track('view_event_calendar');
        observer.disconnect();
      }
    }, { threshold: 0.2 });

    observer.observe(calendar);
  }

  /* Bloc RSVP : sélection de date, état du bouton, begin_rsvp */
  function initRsvp() {
    var block = document.querySelector('[data-garden-rsvp]');
    if (!block) return;

    var form = block.querySelector('form');
    var cards = block.querySelectorAll('.sdp-date-card');
    var submit = block.querySelector('[data-rsvp-submit]');
    var beginFired = false;

    function fireBegin() {
      if (beginFired) return;
      beginFired = true;
      track('begin_rsvp');
    }

    cards.forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      if (!input) return;
      input.addEventListener('change', function () {
        cards.forEach(function (c) {
          c.classList.toggle('is-selected', c === card);
        });
        if (submit) submit.disabled = false;
        fireBegin();
      });
    });

    block.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('focus', fireBegin);
    });

    if (form) {
      var checked = block.querySelector('input[type="radio"]:checked');
      if (submit && !checked) submit.disabled = true;
      form.addEventListener('submit', fireBegin);
    }
  }

  /* Visite libre : sélecteur de date, borne du jour, begin_visite_libre */
  function initLibre() {
    var block = document.querySelector('[data-garden-libre]');
    if (!block) return;

    var form = block.querySelector('form');
    var dateInput = block.querySelector('[data-garden-libre-date]');
    var beginFired = false;

    function fireBegin() {
      if (beginFired) return;
      beginFired = true;
      track('begin_visite_libre');
    }

    if (dateInput) {
      /* La page peut être servie depuis le cache : on remonte la borne basse à aujourd'hui */
      var now = new Date();
      var today =
        now.getFullYear() +
        '-' +
        String(now.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(now.getDate()).padStart(2, '0');
      if (dateInput.min && dateInput.min < today) dateInput.min = today;
      dateInput.addEventListener('change', fireBegin);
    }

    block.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('focus', fireBegin);
    });

    if (form) form.addEventListener('submit', fireBegin);
  }

  function init() {
    initStatusBadges();
    initStickyBar();
    initCalendarTracking();
    initRsvp();
    initLibre();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
